<template>
  <qx-card-form title="申请合作" v-show="otherFormData.hadServer">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="productList" class="productList">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'productId',
        title: [ // 表头
          {
            prop: 'productName',
            label: '产品名称',
          },
          {
            prop: 'address',
            label: '地址',
          },
          {
            prop: 'productInfo',
            label: '产品信息',
          },
        ],
        data: [ // 表格内容
        ],
      },
      otherFormData: {
        hadServer: false,
      },
      baseForm: {
        form: [
          {
            label: '申请合作',
            value: 'productList',
            slot: true,
          },
          {
            label: '邀请说明',
            value: 'applyReason',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.tableData.data = val.serverInfo.applyMap || [];
      this.otherFormData.hadServer = val.serverInfo.info === 2;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
          applyList: this.tableData.selectResult,
        };
      }
      return formData;
    },
    async cacheData () {
      let res = await this.handleSubData(true);
      res.tableList = this.tableData.data;
      return res;
    },

    async sub () {
      if (this.otherFormData.hadServer) {
        const formData = await this.handleSubData();
        if (formData && formData.file[0]) { // 附件
          formData.fileId = formData.file[0].id;
          formData.fileUrl = formData.file[0].url;
        }
        formData.applyList = JSON.stringify(formData.applyList);
        delete formData.file;
        return formData;
      } else {
        return {};
      }
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
      this.tableData.selectResult = data.applyList || [];
      this.tableData.data = data.tableList || [];
    },
  },
};
</script>

<style scoped lang="scss">
.productList{
  margin-top: -8px;
}
</style>
